import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import initCfg from './common/services/config/initCfg';
import initCulture from './common/utility/initCulture';
import initTranslations from './common/services/translations/initTranslations';
import IdentityManager from './common/services/identity/IdentityManagerFactory';
import { canImpersonate, verifyUser } from './core/services/userService';
import { unacceptedAgreements } from './core/services/agreementService';
import BaseURLConfigStore from './common/services/config/baseUrlConfigStore';

import { IMPERSONATE, POPUP, USER } from './redux/types';

import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from '@progress/kendo-react-intl';
import Routes from './routes/routes';
import LoadingScreen from './core/ui/loaders/loadingScreen/loadingScreen';
import ScrollToTop from './core/ui/scrollToTop/scrollToTop';

import './App.scss';


const App: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [langCulture, setLangCulture] = useState<string>('en-GB');
  const [langLoading, setLangLoading] = useState<boolean>(true);
  const [authorized, setAuthorized] = useState<boolean>(true);
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [authLoading, setAuthLoading] = useState<boolean>(true);
  const [showAgreement, setShowAgreement] = useState<boolean>(false);

  const dispatch = useDispatch();

  const authenticate = () => {
    const identity = IdentityManager.getManager();
    identity
      .isAuthenticated()
      .then((isAuthn: boolean | ((prevState: boolean) => boolean)) => {
        setAuthenticated(isAuthn);
        if (isAuthn) {
          return verifyUser().then((user) => {
            let authz = user !== null;
            setAuthorized(authz);
            if (authz) {
              dispatch({ type: USER.SET_NAME, name: user.name });
              if (sessionStorage.length && sessionStorage.getItem('landingPath')) {
                const landingPath = sessionStorage.getItem('landingPath');
                BaseURLConfigStore.setStartPage(landingPath);
                sessionStorage.removeItem('landingPath');
              }
              else if (user.lpStartPage) {
                BaseURLConfigStore.setStartPage(user.lpStartPage);
              }

              return unacceptedAgreements().then((r) => {
                if (r.data.length >= 1) {
                  setShowAgreement(true);
                }
                canImpersonate()
                  .then((r) => {
                    dispatch({ type: IMPERSONATE.CAN_IMPERSONATE, value: r });
                  });
                  //.catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
                setAuthLoading(false);
              });
            } else {

              setAuthLoading(false);
              return Promise.resolve();
            }
          }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
        } else {
          const currentPath = window.location.pathname;
          if (currentPath && currentPath !=='/') {
            sessionStorage.setItem('landingPath', currentPath)
          }
          setAuthLoading(false);
          return Promise.resolve();
        }
      })
      .catch((err: any) => {
        setAuthLoading(false);
        console.error('error loading', err);
      });
  };

  useEffect(() => {
    initCfg()
      .then(() => {
        authenticate();
        initCulture()
          .then((cultureRes) => {
            setLoading(false);
            setLangCulture(cultureRes);
            initTranslations(cultureRes)
              .then(() => {
                setLangLoading(false);
              })
              .catch((err) => console.log('Error initializing translation: ', err));
          })
          .catch((err) => console.log('Error initializing culture: ', err));
      })
      .catch((err) => {
        console.error('Error loading config', err);
      });
  }, []);

  return (
    <>
      {loading || langLoading || authLoading ? (
        <LoadingScreen />
      ) : (
        <IntlProvider locale={langCulture}>
          <Router>
            <ScrollToTop>
              <Routes setShowAgreement={setShowAgreement} authenticated={authenticated} authorized={authorized}
                      showAgreement={showAgreement} />
            </ScrollToTop>
          </Router>
        </IntlProvider>
      )}
    </>
  );
};

export default App;